"use client"

import { type ReactElement, useState } from "react"
import Header from "../Header"
import SideNav from "../SideNav"
import { useRoutes } from "react-router-dom"
import createBreadcrumbs from "@/components/Breadcrumb"

interface IProps {
  children: ReactElement
}

const MainLayout = ({ children }: IProps) => {
  const [isSideNavOpen, setSideNavOpen] = useState(true)
  const breadcrumbs = useRoutes(createBreadcrumbs())
  return (
    <div className="flex w-full min-h-screen bg-background text-foreground">
      <SideNav isSideNavOpen={isSideNavOpen} />
      <div className="flex-1 flex flex-col h-screen overflow-hidden">
        <Header setSideNavOpen={setSideNavOpen} isSideNavOpen={isSideNavOpen} />
        <main className="flex-1 overflow-auto bg-background">
          <div className="w-full h-full p-6 space-y-6">
            {breadcrumbs}
            {children}
          </div>
        </main>
      </div>
    </div>
  )
}

export default MainLayout
